var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.571 18.429l11.529-9.6A1.372 1.372 0 1 0 15.17 6.9zm5.563-10.226l-4.856 3.643L9.921 6.99a.866.866 0 1 1 1.213 1.213m5.876 5.876l-4.856 3.642l3.643-4.855a.865.865 0 1 1 1.213 1.213"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGal);
export default __webpack_public_path__ + "static/media/gal.040e61e1da532a324fd37cd24d970494.svg";
export { ForwardRef as ReactComponent };